import React, { Component, Fragment } from "react";
import { withRouter } from "react-router-dom";
import "./DistrictOverview.scss";
import districtJSON from "../../assets/data/districtDescData.json";
import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  // Legend,
  ResponsiveContainer
} from "recharts";
// import axios from "axios";
import Cookies from "universal-cookie";
import { CAMS_URL, FETCH_URL } from "../../constants/ServerLinks";
import ReactCSSTransitionGroup from "react-addons-css-transition-group";
import downtownImage from "../../assets/images/city1-lowOpacityblue-01.png"
import jacobsHillImage from "../../assets/images/jacobs_hill-01.png"
import mosesGulchImage from "../../assets/images/moses_gulch-02.png"
import corbusvileImage from "../../assets/images/corbusville-01.png"
import howardGardensImage from "../../assets/images/howard_gardens-01.png"


class DistrictOverview extends Component {
  constructor(props) {
    super(props);
    this.cookies = new Cookies();
    this.city_name = this.cookies.get("city_name");
    this.city_id = this.cookies.get("city_id");
    this.student_is_manager = this.cookies.get("student_is_manager");

    this.fetchURL = FETCH_URL;
    this.camsURL = CAMS_URL;

    this.state = {
      districtData: districtJSON,
      metricsJSON: "",
      metricsSelections: [],
      selectedMetric: "",
      selectedPlotData1: [],
      selectedPlotData2: [],
      plotType1: "",
      plotType2: ""
    };
  }

  componentDidMount() {
    // console.log(this.student_is_manager)
    if (this.student_is_manager === "false") {
      // console.log("Inside False")
      this.setState({
        disabledButton: true
      });
    } else if (this.student_is_manager === "true") {
      // console.log("Inside True")
      this.setState({
        disabledButton: false
      });
    }
  }

  render() {
    let districtMetricsName;
    switch (this.props.districtName) {
      case "Downtown":
        districtMetricsName = "Downtown";
        break;
      case "Corbusville":
        districtMetricsName = "Corbusville";
        break;
      case "Moses Gulch":
        districtMetricsName = "MosesGulch";
        break;
      case "Jacobs Hill":
        districtMetricsName = "JacobsHill";
        break;
      case "Howard Gardens":
        districtMetricsName = "HowardGardens";
        break;
      default:
        break;
    }
    // console.log(districtMetricsName);

    // console.log(this.props.districtCurrent);
    // let districtCurrentTest = this.props.districtCurrent.map(item => {
    //   console.log(Object.values(item)[0][0][districtMetricsName]);
    // });
    // console.log(districtCurrentTest);
    let dynamicPlotData;
    if (this.props.combinedDistrictPlotData.length > 1) {
      dynamicPlotData = this.props.combinedDistrictPlotData;
    } else {
      dynamicPlotData = this.props.selectedDistrictPlotData;
    }
    let plotColor = "slategray";

    let districtColor = "";
    let districtPlot = "";
    let forecastedPlot = "";
    let forecastedColor = "";

    switch (window.location.href.split("/")[5]) {
      case "corbusville":
        districtPlot = "Corbusville";
        districtColor = "#5399C9";
        forecastedPlot = "Forecasted Corbusville";
        forecastedColor = "#5399C9";
        break;
      case "downtown":
        districtPlot = "Downtown";
        districtColor = "#FF6302";
        forecastedPlot = "Forecasted Downtown";
        forecastedColor = "#FF6302";
        break;
      case "howard_gardens":
        districtPlot = "HowardGardens";
        districtColor = "#FECE00";
        forecastedPlot = "Forecasted HowardGardens";
        forecastedColor = "#FECE00";
        break;
      case "jacobs_hill":
        districtPlot = "JacobsHill";
        districtColor = "#DF344A";
        forecastedPlot = "Forecasted JacobsHill";
        forecastedColor = "#DF344A";
        break;
      case "moses_gulch":
        districtPlot = "MosesGulch";
        districtColor = "#34A351";
        forecastedPlot = "Forecasted MosesGulch";
        forecastedColor = "#34A351";
        break;
        default:
          break;
    }

    const district = this.state.districtData.filter(
      item => item.screenName === window.location.href.split("/")[5]
    );

    return (
      <div className="policyPanel flex flex-70-30" style={this.props.districtName === "Downtown" ? {backgroundImage: `url(${downtownImage})`} : this.props.districtName === "Jacobs Hill" ? {backgroundImage: `url(${jacobsHillImage})`} : this.props.districtName === "Moses Gulch" ? {backgroundImage: `url(${mosesGulchImage})`} : this.props.districtName === "Corbusville" ? {backgroundImage: `url(${corbusvileImage})`} : this.props.districtName === "Howard Gardens" ? {backgroundImage: `url(${howardGardensImage})`} : null}
      >
        {/* 70 */}
        <div className="frostyBox">
          <div className="policySelection flex">
            <div className="policySelectionHeading">
              {this.props.districtName} -- Overview
            </div>
          </div>
          <p>{district[0].description}</p>
          <div className="districtMetricsWrapper">
            <div className="metricsFlex flex flex-50-50">
              {this.props.districtCurrent.map((item, index) => (
                <div
                  key={index}
                  className="metricColor flex flex-justify-between"
                >
                  <h3
                    style={
                      Object.keys(item)
                        .toString()
                        .includes("Costs")
                        ? { color: "red" }
                        : Object.keys(item)
                            .toString()
                            .includes("Revenue")
                        ? { color: "green" }
                        : null
                    }
                  >
                    {Object.keys(item)} ({this.props.districtName}) :{" "}
                  </h3>
                  <h3
                    style={
                      Object.keys(item)
                        .toString()
                        .includes("Costs")
                        ? { color: "red" }
                        : Object.keys(item)
                            .toString()
                            .includes("Revenue")
                        ? { color: "green" }
                        : null
                    }
                  >
                    {Object.values(item)[0][0].unit === "money"
                      ? `$${Object.values(item)[0][0][districtMetricsName].toFixed(2)
                          .replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,")}`
                      : Object.values(item)[0][0].unit === "percent"
                      ? `${Object.values(item)[0][0][districtMetricsName].toFixed(2)
                          .replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,")}%`
                      : Object.values(item)[0][0].unit === "number"
                      ? `${Object.values(item)[0][0][districtMetricsName].toFixed(2)
                          .replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,")}${
                          Object.keys(item)
                            .toString()
                            .includes("PM")
                            ? "µ"
                            : ""
                        }`
                      : Object.values(item)[0][0][districtMetricsName]}
                  </h3>
                </div>
              ))}
            </div>
          </div>

          {/* <div className="subPolicySelection flex flex-21-79">
            <div className="subPolicy">
              <h1>Sub Policy</h1>
            </div>
            <div className="policyDescription">
            <h1>Policy Description</h1>
            </div>
          </div> */}
        </div>
        {/* 30 */}
        <div
          style={{
            maxWidth: "50%",
            maxHeight: "100%",
            border: "solid 2px #596773",
            borderRadius: "29px",
            padding: "20px",
            backgroundColor: "white",
            background: "rgba(255,255,255,0.5)"
          }}
        >
          <div className="dropdown">
            <select
              className="plotSelect"
              name="selectedDistrictMetric"
              value={this.props.selectedDistrictMetric}
              onChange={e => this.props.onDistrictPlotChange(e)}
              id="selectedDistrictMetric"
            >
              {this.props.selectionAvailable ? (
                <Fragment>
                  <option>Please select Data for Review</option>
                  <optgroup label="---Metrics---">
                    {this.props.metricsSelections.map((item, index) => (
                      <option
                        key={index}
                        value={item}
                        name="selectedDistrictMetric"
                      >
                        {item}
                      </option>
                    ))}
                  </optgroup>
                  <optgroup label="---Costs---">
                    {this.props.costSelections.map((item, index) => (
                      <option
                        key={index}
                        value={item}
                        name="selectedDistrictMetric"
                      >
                        {item}
                      </option>
                    ))}
                  </optgroup>
                  <optgroup label="---Revenue---">
                    {this.props.revenueSelections.map((item, index) => (
                      <option
                        key={index}
                        value={item}
                        name="selectedDistrictMetric"
                      >
                        {item}
                      </option>
                    ))}
                  </optgroup>
                </Fragment>
              ) : (
                <option>Gathering Selections...</option>
              )}
            </select>
          </div>
          {this.props.districtPlotType === "city" ||
          this.props.districtPlotType === "citycost" ||
          this.props.districtPlotType === "cityrevenue" ? (
            <ResponsiveContainer width={"99%"} height="85%">
              <LineChart
                data={dynamicPlotData}
                margin={{ top: 30, right: 10, left: 60, bottom: 5 }}
              >
                <CartesianGrid stroke={plotColor} strokeDasharray="3 3" />
                <XAxis stroke={plotColor} dataKey="year" />
                <YAxis stroke={plotColor} />
                <Tooltip
                  formatter={value => new Intl.NumberFormat("en").format(value)}
                />
                {/* <Legend /> */}
                <Line
                  type="monotone"
                  dataKey="City"
                  stroke="#5399C9"
                  strokeWidth="5px"
                  dot={false}
                />
                <Line
                  type="monotone"
                  dataKey="Forecasted City"
                  stroke="#FF5733"
                  strokeWidth="5px"
                  dot={false}
                  strokeDasharray="10 5"
                />
              </LineChart>
            </ResponsiveContainer>
          ) : null}
          {this.props.districtPlotType === "district" ||
          this.props.districtPlotType === "districtcost" ||
          this.props.districtPlotType === "districtrevenue" ? (
            <ResponsiveContainer width={"99%"} height="85%">
              <LineChart
                data={dynamicPlotData}
                margin={{ top: 30, right: 10, left: 60, bottom: 5 }}
              >
                <CartesianGrid stroke={plotColor} strokeDasharray="3 3" />
                <XAxis stroke={plotColor} dataKey="year" />
                <YAxis stroke={plotColor} />
                <Tooltip
                  formatter={value => new Intl.NumberFormat("en").format(value)}
                />
                {/* <Legend /> */}
                <Line
                  type="monotone"
                  dataKey={districtPlot}
                  stroke={districtColor}
                  strokeWidth="5px"
                  dot={false}
                />
                <Line
                  type="monotone"
                  dataKey={forecastedPlot}
                  stroke={forecastedColor}
                  strokeWidth="5px"
                  dot={false}
                  strokeDasharray="10 5"
                />
              </LineChart>
            </ResponsiveContainer>
          ) : null}
          {this.props.districtPlotType === "transportation" ? (
            <ResponsiveContainer width={"99%"} height="85%">
              <LineChart
                data={dynamicPlotData}
                margin={{ top: 30, right: 10, left: 60, bottom: 5 }}
              >
                <CartesianGrid stroke={plotColor} strokeDasharray="3 3" />
                <XAxis stroke={plotColor} dataKey="year" />
                <YAxis stroke={plotColor} />
                <Tooltip
                  formatter={value => new Intl.NumberFormat("en").format(value)}
                />
                {/* <Legend /> */}
                <Line
                        type="monotone"
                        dataKey="Car"
                        stroke="#5399C9"
                        strokeWidth="5px"
                        dot={false}
                      />
                      <Line
                        type="monotone"
                        dataKey="Rail"
                        stroke="#FF6302"
                        strokeWidth="5px"
                        dot={false}
                      />
                      <Line
                        type="monotone"
                        dataKey="Bus"
                        stroke="#FECE00"
                        strokeWidth="5px"
                        dot={false}
                      />
                      <Line
                        type="monotone"
                        dataKey="Walk"
                        stroke="#DF344A"
                        strokeWidth="5px"
                        dot={false}
                      />
                      <Line
                        type="monotone"
                        dataKey="Bike"
                        stroke="#80B43A"
                        strokeWidth="5px"
                        dot={false}
                      />

                      <Line
                        type="monotone"
                        dataKey="Forecasted Walk"
                        stroke="#DF344A"
                        strokeWidth="5px"
                        strokeDasharray="10 5"
                        dot={false}
                      />

                      <Line
                        type="monotone"
                        dataKey="Forecasted Car"
                        stroke="#5399C9"
                        strokeWidth="5px"
                        strokeDasharray="10 5"
                        dot={false}
                      />

                      <Line
                        type="monotone"
                        dataKey="Forecasted Rail"
                        stroke="#FF6302"
                        strokeWidth="5px"
                        strokeDasharray="10 5"
                        dot={false}
                      />

                      <Line
                        type="monotone"
                        dataKey="Forecasted Bus"
                        stroke="#FECE00"
                        strokeWidth="5px"
                        strokeDasharray="10 5"
                        dot={false}
                      />
                      <Line
                        type="monotone"
                        dataKey="Forecasted Bike"
                        stroke="#80B43A"
                        strokeWidth="5px"
                        strokeDasharray="10 5"
                        dot={false}
                      />
              </LineChart>
            </ResponsiveContainer>
          ) : null}
          <ReactCSSTransitionGroup
            transitionName="fade"
            transitionAppear={true}
            transitionAppearTimeout={500}
            transitionEnterTimeout={500}
            transitionLeaveTimeout={300}
          >
            {this.props.districtPlotType ? (
              <p>Please hover over plot for data.</p>
            ) : null}
          </ReactCSSTransitionGroup>
        </div>
      </div>
    );
  }
}

export default withRouter(DistrictOverview);
